module.exports = __webpack_public_path__ + "static/noble-3fd60bae9a0e08286437cbab16e5526f.jpg";